<template>
    <div id="doctor-panel-container">
        <MdTitle v-bind:Text="$t('userHeader.DoctorInfo')" v-bind:isSubtitle="true" v-bind:Name="'T_DOCTOR_SUBTITLE'"/>

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('employee.Company')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'Company'"
                    v-bind:MaxLengthProp="50"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.company"
                    v-bind:Id="'input_d_company'">                                     
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('doctor.ContactFirstName')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'ContactFirstName'"
                    v-bind:MaxLengthProp="50"
                    v-model="editableItem.contactFirstName"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_d_cont_fn'">
                </MdEdit>
            </b-col>      
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('doctor.ContactLastName')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'ContactLastName'"
                    v-bind:MaxLengthProp="50"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.contact"
                    v-bind:Id="'input_d_cont_ln'">                                     
                </MdEdit>
            </b-col>   
        </b-row>
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('doctor.LOCALITY')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'Locality'"
                    v-bind:MaxLengthProp="3"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.locality"
                    v-bind:Id="'input_d_loc'">                                     
                </MdEdit>
            </b-col>  
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('doctor.DoctorID')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'doctorId'"
                    v-bind:MaxLengthProp="15"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.doctorId">                                     
                </MdEdit>
            </b-col>                            
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('employee.Credentials')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'Credentials'"
                    v-bind:MaxLengthProp="9"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.credentials"
                    v-bind:Id="'input_d_cred'">                                     
                </MdEdit>
            </b-col>      
        </b-row>

        <MdTitle v-bind:Text="$t('userHeader.DoctorReference')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        <b-row>
            <b-col sm="12" md="3" lg="3">  
                <MdEdit 
                    v-bind:Label="$t('doctor.Upin')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'Country'"
                    v-bind:MaxLengthProp="6"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.upin"
                    v-bind:Id="'input_d_uoin'">                                     
                </MdEdit>
            </b-col>
            <b-col sm="12" md="3" lg="3">  
                <MdEdit 
                    v-bind:Label="$t('Contact.SSN')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'SSN'"
                    v-bind:MaxLengthProp="11"
                    v-bind:Mask="'###-##-####'"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.ssn"
                    v-bind:Id="'input_d_ssn'">                                     
                </MdEdit>
            </b-col>
            <b-col sm="12" md="3" lg="3">  
                <MdEdit 
                    v-bind:Label="'EIN'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'EIN'"
                    v-bind:MaxLengthProp="10"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.ein"
                    v-bind:Id="'input_d_ein'">                                     
                </MdEdit>
            </b-col>
            <b-col sm="12" md="3" lg="3">  
                <MdEdit 
                    v-bind:Label="$t('doctor.LicenceNo')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'LicenceNo'"
                    v-bind:MaxLengthProp="15"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.me">                                     
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12" md="3" lg="3">  
                <MdEdit 
                    v-bind:Label="'NPI'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'NPI'"
                    v-bind:MaxLengthProp="15"
                    v-bind:isReadOnly="isReadOnly"
                    v-model="editableItem.npi"
                    v-bind:Id="'input_d_npi'">                                     
                </MdEdit>
            </b-col>
            <b-col sm="12" md="3" lg="3">  
                <MdSelect
                    v-bind:Label="$t('doctor.Specialty')"
                    v-bind:Options="specialtyList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="editableItem.type"                       
                    v-bind:Multiple="false"
                    :Input="ChangeSpecialty"
                    v-bind:IsDisabled="isReadOnly"
                />
            </b-col>
        </b-row>

        <provider-panel
            :insuranceList="insuranceList"
            :isReadOnly="isReadOnly"
            v-model="editableItem.providerCodesList"
            :label="this.$t('userHeader.DoctorProviders')"
        >
        
        </provider-panel>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import ProviderPanel from './providerPanel.vue';

export default {
    mixins: [ShowMessage, DBFunctions],
    name: 'DoctorPanel',
    props: {
        value: {
            type: Object,
            required: () => true
        },
        Mode: {
            type: Boolean,
            required: true
        },
        isReadOnly: {
            type: Boolean,
            default: false
        },
        specialtyList: {
            type: Array,
            required: true
        },
        insuranceList: {
            type: Array,
            required: true
        }
    },
    components: {
        ProviderPanel
    },

    data() {
        const defaultDoctorProps = {
            code: '',
            company: '',
            contactFirstName: '',
            contact: '',
            locality: '',
            doctorId: '',
            credentials: '',
            upin: '',
            ssn: '',
            ein: '',
            me: '',
            npi: '',
            type: '',
            providerCodesList: []
        };

        return {
            defaultDoctorProps: defaultDoctorProps,
            editableItem: this.value || defaultDoctorProps,
        }
    },

    watch: {
        value(newValue) {
            this.$set(this, 'editableItem', newValue || this.defaultDoctorProps);
        }
    },

    methods: {
        ChangeSpecialty(value){
            this.editableItem.type = value ? value.code : null;
            this.$emit('input', this.editableItem);
        },
    },
}
</script>